const API_HOST_V1 = `${window.ENV_CONFIG.hosts.orders}/api/v1-0`;

export const getOrdersForPrintEndpoint = () => `${API_HOST_V1}/orders/print`;
export const getPrintersEndpoint = () => `${API_HOST_V1}/printers`;
export const postSendOrdersToPrintEndpoint = () =>
  `${API_HOST_V1}/orders/print`;
export const assignNewPrintBatchIdEndpoint = orderId =>
  `${API_HOST_V1}/orders/${orderId}/assign-to-new-shipment`;
